import http from "../../services/http";
import { setBook, setBookChapters } from "../entities/student";
import { setBookLoader } from "../ui/loaders";
import { updateUser } from "../auth/authReducer";
const path = "api/student";

const getBook = ({ onSuccess, onError, onEnd, id = "" }) => {
  return async (dispatch, getState) => {
    dispatch(setBookLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/bookdetailsbystudent?book=${id}`,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      dispatch(setBookChapters(res.data.data.chapters));
      dispatch(setBook(res.data.data.book));
      dispatch(setBookLoader(false));
      if (onSuccess) onSuccess(res);
    } catch (error) {
      dispatch(setBookLoader(false));
      if (onError) onError(error);
    } finally {
      dispatch(setBookLoader(false));
      if (onEnd) onEnd();
    }
  };
};
const paymentIntent = ({ onSuccess, onError, onEnd, id = "", body = {} }) => {
  return async (dispatch, getState) => {
    dispatch(setBookLoader(true));
    try {
      const store = getState();
      const res = await http.put({
        url: path + `/create-payment-intent/`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const payment = ({ onSuccess, onError, onEnd, body, id = "" }) => {
  return async (dispatch, getState) => {
    dispatch(setBookLoader(true));
    try {
      const store = getState();
      const res = await http.post({
        url: path + `/payment`,
        body,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const me = ({ onSuccess, onError, onEnd, body, id = "" }) => {
  return async (dispatch, getState) => {
    dispatch(setBookLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/me`,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
      dispatch(updateUser(res.data.data));
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
const myTransactions = ({ onSuccess, onError, onEnd, body, id = "" }) => {
  return async (dispatch, getState) => {
    dispatch(setBookLoader(true));
    try {
      const store = getState();
      const res = await http.get({
        url: path + `/my_transactions`,
        headers: {
          "x-auth-token": store.auth.token,
        },
      });
      if (onSuccess) onSuccess(res);
    } catch (error) {
      if (onError) onError(error);
    } finally {
      if (onEnd) onEnd();
    }
  };
};
export { getBook, paymentIntent, payment, me, myTransactions };
